import { SectionHeading, Reveal } from "./Reveal";

function QuoteCard({ t, testid }) {
  return (
    <figure
      data-testid={testid}
      className="w-full rounded-lg border border-lavender-700/10 bg-white p-7 shadow-soft"
    >
      <p data-testid={`${testid}-rating`} className="text-sm font-bold text-lavender-700">{t.stars || 5} / 5 rating</p>
      <blockquote className="mt-4 text-sm leading-relaxed text-stone-700">“{t.quote}”</blockquote>
      <figcaption className="mt-5 flex flex-wrap items-center gap-x-2 text-sm">
        <span className="font-semibold text-stone-900">{t.name}</span>
        {t.dogName && <span className="text-stone-500">· {t.dogName}'s owner</span>}
      </figcaption>
    </figure>
  );
}

export default function Reviews({ testimonials }) {
  if (!testimonials.length) return null;
  return (
    <section id="reviews" data-testid="reviews-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          kicker="Reviews"
          title="What our clients say."
          description="A few words from the people who bring their dogs to us."
        />
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="reviews-grid">
          {testimonials.map((t, i) => (
            <Reveal key={t.id || i} delay={0.06 * (i % 3)}>
              <QuoteCard t={t} testid={`review-card-${i}`} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
